<template>
	<div class="unsubscribed">
		<div class="unsubscribed-sub-cont">
			<div class="header5">Hi! There</div>
			<div class="header2"></div>
			<div class="unsubscribed-text">
				<div>
					You have successfully unsubscribed
					<br />
					from the selected mailings!
				</div>
			</div>
			<div>
				<div class="paragraph back-forgot">Back to <span @click="goHome">Home!</span></div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "unsubscribed",
	title: "Unsubscribed",
	components: {},
	data() {
		return {};
	},
	mounted() {},
	methods: {
		goHome() {
			this.$router.push({ name: "Home" });
		},
	},
	computed: {},
};
</script>

<style scoped lang="scss">
.unsubscribed {
	text-align: left;
	flex-direction: column;
	padding: 65px 60px;
	.unsubscribed-text {
		background: var(--dark-blue);
		text-align: left;
		padding: 47px 16px;
		display: flex;
		font-style: normal;
		font-weight: normal;
		font-size: 36px;
		line-height: 84px;
		color: var(--white);
		padding: 65px 60px;
		margin: -65px;
		height: 550px;
	}
	.unsubscribed-sub-cont {
		.header5 {
			color: var(--accent);
			font-size: 18px;
			margin-bottom: 20px;
		}
		.header2 {
			color: var(--white);
			font-size: 51px;
			line-height: 51px;
		}
		.paragraph {
			width: 500px;
			text-align: center;
			margin: auto;
			color: var(--white);
			margin-top: 20px;
		}
	}
	.back-forgot {
		color: white;
		margin-top: 2px;
		width: 500px;
		text-align: left;
		margin: auto;
		opacity: 1;
		span {
			font-style: normal;
			font-weight: 500;
			font-size: 18px;
			line-height: 27px;
			text-align: center;
			cursor: pointer;
			color: rgba(80, 205, 243, 1);
		}
		& :hover {
			color: var(--primary);
		}
	}
}
</style>
